import { BasicRequest, HTTPMethod, APIVersion } from "../requests/request";
import { Contest } from "../models/contest";

export class API {

    /**
     * Sign up for an contest
     * @returns {Promise<Contest>} The Promise contains either a device or an APIError if rejected
     */
    public static track(events: Object[], platform: 'create' | 'supreme' | 'latino' | 'sync'): Promise<void> {
        let apiRequest = new BasicRequest<Contest>('/analytics/track/' + platform, HTTPMethod.POST, APIVersion.v3_0, undefined, {
            events
        });
        return apiRequest.send().then((data) => {
            return void 0;
        })
    }

}


// WEBPACK FOOTER //
// ./src/api/src/endpoints/analytics.ts